import { render } from "./WpeUrl.vue?vue&type=template&id=a9fd55a6"
import script from "./WpeUrl.vue?vue&type=script&lang=js"
export * from "./WpeUrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeUrl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9fd55a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9fd55a6', __exports__)) {
    api.reload('a9fd55a6', __exports__)
  }
  
  module.hot.accept("./WpeUrl.vue?vue&type=template&id=a9fd55a6", () => {
    api.rerender('a9fd55a6', render)
  })

}


export default __exports__